module.exports = __webpack_public_path__ + "img/기업네트워킹.ac63666e.png";